import React, {ReactElement, useState} from 'react';
import Skeleton from '@mui/material/Skeleton';

const ImageWithPlaceholder = ({
  height,
  width,
  src,
  classes
}: {
  height: number;
  width: number;
  src: string;
  classes: string;
}): ReactElement => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div>
      {!loaded && (
        <Skeleton variant="rectangular" width={width} height={height} />
      )}
      <img
        className={classes}
        style={loaded ? {} : {display: 'none'}}
        alt="Product"
        src={src}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default ImageWithPlaceholder;
